import { routeSlugFromIdentifierAndTitle } from '@/js/core/utils/route-slug';

const UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/i;

/**
 * Build the frontend equivalent of the backend tray route slug.
 */
export function trayRouteSlugFromValues(trayUuid, title) {
  return routeSlugFromIdentifierAndTitle(trayUuid, title);
}

/**
 * Return the canonical tray route slug, preferring the server-presented path.
 */
export function trayRouteSlug(tray) {
  const pathSlug = trayRouteSlugFromPath(tray?.path);
  if (pathSlug) return pathSlug;

  const presentedSlug = String(tray?.tray_page_slug || '').trim();
  if (presentedSlug) return presentedSlug;

  return trayRouteSlugFromValues(tray?.uuid, tray?.title);
}

/**
 * Return Vue Router params for the tray detail route.
 */
export function trayRouteParams(tray) {
  return {
    traySlug: trayRouteSlug(tray),
  };
}

/**
 * Extract the UUID candidate from a tray route slug before canonical validation.
 */
export function trayUuidFromRouteSlug(routeSlug) {
  const slug = decodeRouteSegment(routeSlug)
    .trim()
    .replace(/^\/+|\/+$/g, '');
  if (!slug) return null;

  const match = slug.match(UUID_PATTERN);
  if (!match || (slug[match[0].length] && slug[match[0].length] !== '-')) {
    return null;
  }

  return match[0].toLowerCase();
}

/**
 * Match a tray against the canonical route slug used by the backend.
 */
export function matchesTrayRouteSlug(tray, routeSlug) {
  const slug = trayRouteSlug(tray);
  if (!slug) return false;

  return routeSlugVariants(routeSlug).some(value => value === slug);
}

function trayRouteSlugFromPath(path) {
  const value = String(path || '').trim();
  const match = value.match(/^\/trays\/([^/]+)$/);

  return match ? decodeRouteSegment(match[1]) : '';
}

function routeSlugVariants(routeSlug) {
  const value = String(routeSlug || '')
    .trim()
    .replace(/^\/+|\/+$/g, '');
  const decoded = decodeRouteSegment(value);

  return [...new Set([value, decoded].filter(Boolean))];
}

function decodeRouteSegment(value) {
  try {
    return decodeURIComponent(String(value || ''));
  } catch {
    return String(value || '');
  }
}
